export const fonts = {
    h1: '2.3rem',
    h2: '1.6rem',
    p: '1.4rem',
    p1: '1.2rem',
    h1Big: '3rem',
    h2Big: '2.6rem',
    pBig: '1.6rem'
  };
  